export default "__VITE_ASSET__w5Zf0EIQ__";